module.exports = __webpack_public_path__ + "static/img/energy_256.1dc5f55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/energy_256.png
// module id = dURV
// module chunks = 0